/**
 * @fileoverview GET handler for the "/offerfit/:app_group_id/use_cases/:use_case_id/token" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { offerfitAppGroupIdUseCasesUseCaseIdToken } from "./constants";
import type {
  GetOfferfitAppGroupIdUseCasesUseCaseIdTokenParams,
  OfferfitAppGroupIdUseCasesUseCaseIdTokenResult,
} from "./types";

export const getOfferfitAppGroupIdUseCasesUseCaseIdToken = reactQueryFetcherAdapter(
  offerfitAppGroupIdUseCasesUseCaseIdToken,
  (
    signal: AbortSignal,
    { appGroupId, useCaseId }: GetOfferfitAppGroupIdUseCasesUseCaseIdTokenParams
  ): Promise<OfferfitAppGroupIdUseCasesUseCaseIdTokenResult> => {
    return fetch(
      `/offerfit/${appGroupId}/use_cases/${useCaseId}/token`,
      "GET",
      undefined,
      { signal },
      {
        propagateFetchRequestError: false,
      }
    );
  }
);
